var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "basic-container",
        [
          _c("div", { staticClass: "page-container entity-present-log-page" }, [
            _c(
              "div",
              { staticClass: "query-form-wrap" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      inline: true,
                      model: _vm.searchForm,
                      size: _vm.formSize,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          staticStyle: { width: "350px" },
                          attrs: {
                            size: "small",
                            clearable: "",
                            placeholder: "UID、MAC地址、AndroID或IDFA、手机号",
                          },
                          model: {
                            value: _vm.searchForm.search,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "search", $$v)
                            },
                            expression: "searchForm.search",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: "small",
                              filterable: "",
                              clearable: "",
                              placeholder: "风险等级",
                            },
                            model: {
                              value: _vm.searchForm.level,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "level", $$v)
                              },
                              expression: "searchForm.level",
                            },
                          },
                          _vm._l(_vm.riskLevel, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.key, value: item.level },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: "small",
                              filterable: "",
                              clearable: "",
                              placeholder: "录入方式",
                            },
                            model: {
                              value: _vm.searchForm.enterType,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "enterType", $$v)
                              },
                              expression: "searchForm.enterType",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "自动", value: "1" },
                            }),
                            _c("el-option", {
                              attrs: { label: "手动", value: "0" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "SECURITY_RISKDEVICES_SEARCH",
                                expression: "'SECURITY_RISKDEVICES_SEARCH'",
                              },
                            ],
                            attrs: {
                              loading: _vm.listLoading,
                              icon: "el-icon-search",
                              type: "primary",
                            },
                            on: { click: _vm.doSearch },
                          },
                          [_vm._v("查询")]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "SECURITY_RISKDEVICES_ADD",
                                expression: "'SECURITY_RISKDEVICES_ADD'",
                              },
                            ],
                            attrs: {
                              type: "success",
                              plain: "",
                              icon: "el-icon-plus",
                            },
                            on: {
                              click: function ($event) {
                                _vm.showAddRiskDevice = true
                              },
                            },
                          },
                          [_vm._v("新增")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "table-wrap" },
              [
                _c("avue-crud", {
                  ref: "crud",
                  attrs: {
                    option: _vm.options,
                    data: _vm.tableData,
                    page: _vm.page,
                  },
                  on: {
                    "update:page": function ($event) {
                      _vm.page = $event
                    },
                    "refresh-change": _vm.getList,
                    "on-load": _vm.getList,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "level",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.getDeviceLRiskLevel(scope.row.level)) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                    {
                      key: "menu",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "auth",
                                  rawName: "v-auth",
                                  value: "SECURITY_RISKDEVICES_LOG",
                                  expression: "'SECURITY_RISKDEVICES_LOG'",
                                },
                              ],
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.rowLog(row)
                                },
                              },
                            },
                            [_vm._v("\n              日志\n            ")]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "auth",
                                  rawName: "v-auth",
                                  value: "SECURITY_RISKDEVICES_VIEW",
                                  expression: "'SECURITY_RISKDEVICES_VIEW'",
                                },
                              ],
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.viewRow(row)
                                },
                              },
                            },
                            [_vm._v("\n              详情\n            ")]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "auth",
                                  rawName: "v-auth",
                                  value: "SECURITY_RISKDEVICES_EDIT",
                                  expression: "'SECURITY_RISKDEVICES_EDIT'",
                                },
                              ],
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.editRow(row)
                                },
                              },
                            },
                            [_vm._v("\n              编辑\n            ")]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "auth",
                                  rawName: "v-auth",
                                  value: "SECURITY_RISKDEVICES_DEL",
                                  expression: "'SECURITY_RISKDEVICES_DEL'",
                                },
                              ],
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.del(row.id)
                                },
                              },
                            },
                            [_vm._v("\n              删除\n            ")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]),
          _c("AddRiskDevices", {
            attrs: { riskLevel: _vm.riskLevel, visible: _vm.showAddRiskDevice },
            on: {
              "update:visible": function ($event) {
                _vm.showAddRiskDevice = $event
              },
              reload: _vm.getList,
            },
          }),
          _c("EditRiskDevices", {
            attrs: {
              riskLevel: _vm.riskLevel,
              riskDevice: _vm.editRiskDeviceObj,
              visible: _vm.editVisible,
            },
            on: {
              "update:visible": function ($event) {
                _vm.editVisible = $event
              },
              reload: _vm.getList,
            },
          }),
          _c("RiskDeviceDetail", {
            attrs: {
              riskLevel: _vm.riskLevel,
              riskDevice: _vm.editRiskDeviceObj,
              visible: _vm.viewVisible,
            },
            on: {
              "update:visible": function ($event) {
                _vm.viewVisible = $event
              },
            },
          }),
          _c("RiskDeviceLog", {
            attrs: { id: _vm.deviceId, visible: _vm.logVisible },
            on: {
              "update:visible": function ($event) {
                _vm.logVisible = $event
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }